import { of } from 'rxjs/observable/of';
import { logoutAction, errorAction } from '../../reducers/actions';
import { I18n } from 'react-redux-i18n';

/**
  Code to run when an API call fails
  @function apiErrorHandling
  @param {Observable} action$
  @returns {Observable}
*/
export const apiErrorHandling = actionToCall => error => {
  if (error.status === 400) {
    return of(actionToCall(I18n.t('error.400'), true));
  } else if (error.status === 403) {
    return of(actionToCall(I18n.t('error.403'), true));
  } else if (error.status === 500) {
    return of(actionToCall(I18n.t('error.500', true)));
  } else if (error.status === 401 && error.response.error === 'invalid_token') {
    return of(logoutAction());
  } else {
    setTimeout(() => {
      throw error;
    }, 0);
    return of(errorAction(error));
  }
};



// WEBPACK FOOTER //
// ./src/utils/epics/apiErrorHandling.js